import React from "react";
import { SecondaryButton, SuccessButton, Modal } from "../../design-system";
import { typography } from "../../design-system/tokens";

const PublishButton = ({ 
  onPublish, 
  disabled,
  publishConfirmOpen,
  setPublishConfirmOpen,
  onConfirmPublish,
  publishing
}) => {
  return (
    <>
      <SuccessButton
        onClick={onPublish}
        disabled={disabled}
        size="sm"
        className="text-xs lg:text-sm px-2.5 lg:px-3.5 py-1 lg:py-1.5"
      >
        Publish
      </SuccessButton>

      {/* Publish confirmation modal */}
      <Modal
        isOpen={publishConfirmOpen}
        onClose={() => setPublishConfirmOpen(false)}
        title="Publish website"
      >
        <p className={`${typography.body} mb-6`}>Publish all saved changes to your live site?</p>
        <div className="flex items-center justify-end space-x-3">
          <SecondaryButton onClick={() => setPublishConfirmOpen(false)}>
            No
          </SecondaryButton>
          <SecondaryButton
            onClick={onConfirmPublish}
            disabled={publishing}
            variant="primary"
          >
            {publishing ? "Publishing..." : "Yes"}
          </SecondaryButton>
        </div>
      </Modal>
    </>
  );
};

export default PublishButton;

